/* eslint-disable camelcase */
// const env = 'development' /** nyalain kalo mau tes di develop */
// console.log('process.env.REACT_APP_ENV', process.env.REACT_APP_ENV)
let env = 'staging'
if (__BROWSER__) {
  env = window.App.env || 'production'
} else {
  env = process.env.REACT_APP_ENV
}

const options = {
  development: {
    port: 3000,
    endpoints: {
      clientUrl: '',
      serverUrl: 'https://stag.mola.tv',
      api: '/api/v2', //kalo mau push balikin lagi ke awal api: 'https://stag.mola.tv/api/v2',
      apiArticles: 'https://stag.mola.tv/api/v2/articles',
      auth: '/accounts/_',
      domain: 'https://stag.mola.tv',
      uploader: 'https://up.stag.mola.tv',
      stats: 'http://api.stats.com/v1',
      redeem: 'http://promos.payment.sstv.local/external/voucher/redeem',
      ads: 'https://api.stag.supersoccer.tv',
      analytic: 'https://api.stag.supersoccer.tv',
      asset: 'https://cdn.stag.supersoccer.tv/mola/assets-global',
      setting: {
        timeout: 10000,
        maxRedirects: 1,
      },
    },
  },
  staging: {
    port: 3000,
    endpoints: {
      clientUrl: '',
      serverUrl: 'https://stag.mola.tv',
      api: 'https://stag.mola.tv/api/v2', //kalo mau push balikin lagi ke awal api: 'https://stag.mola.tv/api/v2',
      apiArticles: 'https://stag.mola.tv/api/v2/articles',
      auth: 'https://stag.mola.tv/accounts/_',
      domain: 'https://stag.mola.tv',
      uploader: 'https://up.stag.mola.tv',
      stats: 'http://api.stats.com/v1',
      redeem: 'http://promos.payment.sstv.local/external/voucher/redeem',
      ads: 'https://api.stag.supersoccer.tv',
      analytic: 'https://api.stag.supersoccer.tv',
      asset: 'https://cdn.stag.supersoccer.tv/mola/assets-global',
      setting: {
        timeout: 10000,
        maxRedirects: 1,
      },
    },
  },
  production: {
    port: 3000,
    endpoints: {
      clientUrl: '',
      serverUrl: 'https://mola.tv',
      api: 'https://mola.tv/api/v2',
      auth: 'https://mola.tv/accounts/_',
      domain: 'https://mola.tv',
      uploader: 'https://up.mola.tv',
      stats: 'http://api.stats.com/v1',
      redeem: 'http://promos.payment.sstv.local/external/voucher/redeem',
      ads: 'https://api.sent.tv',
      analytic: 'https://api.sent.tv',
      asset: 'https://mola01.koicdn.com/assets-global',
      setting: {
        timeout: 10000,
        maxRedirects: 1,
      },
    },
  },
}

const config = options[env]

module.exports = {
  // Node.js app
  env,
  ...config,
}
